import React from "react";
import "../css/MarketSpaceForm.css";
import { connect } from "react-redux";
import deleteIcon from './../assets/images/delete.svg';
import * as ActionTypes from "../actions/types";
import Loader from './Loader';
// import { MenuItem, TextField } from '@mui/material';
import Indflag from '../assets/images/indian_flag.png';
import Africaflaf from '../assets/images/south-africa.png';
import Ausflag from '../assets/images/aus-flag.png';
import UAEflag from '../assets/images/USA_flag.png';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { Tooltip } from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox
} from "@mui/material";




const distributorCountry = [
    { imageSrc: Ausflag, label: 'AUSTRALIA' },
    { imageSrc: Africaflaf, label: 'AFRICA' },
    { imageSrc: UAEflag, label: 'UAE' },
    { imageSrc: Indflag, label: 'INDIA' },
];


class MarketSpaceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            snackbarActive: false,
            snackbarMessage: "",
            isChecked: false, // Initially checkbox is unchecked
            bannerImage: null, // To store the selected banner image
            iconImage: null, // To store the selected icon image
            percentage_off: "", // Store the value for offer in percentage
            start_date: "",
            end_date: "",
            max_usage: "",
            price: '',
            DistributorCountry: '',
            distributorPrices: [],
            coupon: "", // Store the value for coupon id
            fields: [], // Store the list of input field sets
            updatedPrices: [],
            name: "",
            features: "",
            description: "",
            editorChoice: false,
            mostDownloaded: false,
            personalized: false,
            aiEnabled: false,
            freeTrialPeriod: 0,
            costPerDownload: "",
            status: "active",
            activeData: [],
            doewnloadsData: [],
            active_usersData: [],
            open: false,
            distributorData: [],
            distributorPermissions: [],
            uncheckedDistributors: [],
            recheckedDistributors: [],
            checkedDistributorIds: []
        };
    }


    fetchDistributor = () => {
        this.setState({
            loader: true
        })
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/distributors/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                //  console.log(data.data);
                this.setState({
                    distributorData: data.data,
                    // actualData: data.data,
                    loader: false
                })


            })
            .catch((err) => {
                console.log(err)

            })
    }


    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };



    // Handle banner image upload
    // handleBannerUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         this.setState({ bannerImage: file });
    //     }
    // };
    handleBannerUpload = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
        const allowedExtensions = /\.(png|jpe?g|svg)$/i;

        if (file && allowedTypes.includes(file.type) && allowedExtensions.test(file.name)) {
            this.setState({ bannerImage: file });
        } else {
            alert('❌ Invalid file. Only .png, .jpg, .jpeg, .svg images are allowed.');
        }
    };


    // Handle icon image upload
    // handleIconUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         this.setState({ iconImage: file });
    //     }
    // };
    handleIconUpload = (e) => {
        const file = e.target.files[0];

        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
        if (file && allowedTypes.includes(file.type)) {
            this.setState({ iconImage: file });
        } else {
            alert('Only image files (.png, .jpg, .jpeg, .svg) are allowed.');
        }
    };


    handleCheckboxChange = (event) => {
        this.setState({ isChecked: event.target.checked });
    };

    // Handle changes to the input fields
    handleInputChange = (event, field) => {
        this.setState({ [field]: event.target.value });
    };

    onSelectChange = (field, value) => {
        // console.log(value);
        this.setState({ [field]: value });
    };


    // handleAddField = () => {
    //     const { percentage_off, coupon, start_date, end_date, max_usage } = this.state;

    //     // Store missing fields
    //     const missingFields = [];

    //     if (!percentage_off) missingFields.push("Offer in Percentage");
    //     if (!coupon) missingFields.push("Coupon ID");
    //     if (!start_date) missingFields.push("Start Date");
    //     if (!end_date) missingFields.push("End Date");
    //     if (!max_usage) missingFields.push("Max Use");

    //     // If any field is missing, show an alert
    //     if (missingFields.length > 0) {
    //         alert(`Please fill out the following fields before adding:\n\n${missingFields.join("\n")}`);
    //         return;
    //     }

    //     // Add new entry and reset the fields
    //     this.setState((prevState) => ({
    //         fields: [
    //             ...prevState.fields,
    //             { percentage_off, coupon, start_date, end_date, max_usage },
    //         ],
    //         percentage_off: "",
    //         coupon: "",
    //         start_date: "",
    //         end_date: "",
    //         max_usage: "",
    //     }));
    // };

    handleAddField = () => {
        const { percentage_off, coupon, start_date, end_date, max_usage, fields } = this.state;

        // Store missing fields
        const missingFields = [];

        if (!percentage_off) missingFields.push("Offer in Percentage");
        if (!coupon) missingFields.push("Coupon ID");
        if (!start_date) missingFields.push("Start Date");
        if (!end_date) missingFields.push("End Date");
        if (!max_usage) missingFields.push("Max Use");

        // If any field is missing, show an alert
        if (missingFields.length > 0) {
            alert(`Please fill out the following fields before adding:\n\n${missingFields.join("\n")}`);
            return;
        }

        // 🔁 Check if the coupon already exists
        const isDuplicate = fields.some((field) => field.coupon === coupon);
        if (isDuplicate) {
            alert("This coupon ID has already been added. Please use a unique one.");
            return;
        }

        // ✅ Add new entry and reset the fields
        this.setState((prevState) => ({
            fields: [
                ...prevState.fields,
                { percentage_off, coupon, start_date, end_date, max_usage },
            ],
            percentage_off: "",
            coupon: "",
            start_date: "",
            end_date: "",
            max_usage: "",
        }));
    };


    handleAddCountryPriceField = () => {
        const { DistributorCountry, price } = this.state;

        const missingFields = [];

        if (!DistributorCountry) missingFields.push("Country");
        if (!price) missingFields.push("Price");

        if (missingFields.length > 0) {
            alert(`Please fill out the following fields before adding:\n\n${missingFields.join("\n")}`);
            return;
        }

        // console.log("Adding country-price pair:", {
        //     country: DistributorCountry,
        //     price: price,
        // });

        this.setState((prevState) => {
            //  console.log("Previous distributorPrices:", prevState.distributorPrices);

            const updatedPrices = [
                ...prevState.distributorPrices,
                { country: DistributorCountry, price: price },
            ];

            console.log("Updated distributorPrices:", updatedPrices);

            return {
                distributorPrices: updatedPrices,
                DistributorCountry: '',
                price: ''
            };
        });
    };

    // Handle delete functionality
    handleDelete = (index) => {
        this.setState((prevState) => ({
            fields: prevState.fields.filter((_, i) => i !== index), // Remove the field at the given index 
        }));
        //console.log(this.state.fields);
    };

    handleDeleteCountryPrice = (index) => {
        this.setState((prevState) => ({
            distributorPrices: prevState.distributorPrices.filter((_, i) => i !== index), // Remove the field at the given index
        }));
    }



    componentDidMount() {
        this.fetchDistributor();
        // this.getDistributorPermissions();
        // Extract 'id' from the query parameters (e.g., URL like /marketspaceFormEdit?id=15)
        const searchParams = new URLSearchParams(window.location.search);
        const itemId = searchParams.get("id"); // Get the `id` query parameter

        if (itemId) {
            this.fetchActiveService(itemId);
        } else {
            console.warn("No ID provided in the URL. Cannot fetch specific data.");
        }
    }

    fetchActiveService = (itemId) => {

        this.setState({ loader: true });
        const tokenStored = localStorage.getItem("token");
        const headers = {
            Authorization: `Token ${tokenStored}`,
            "X-CSRFToken": localStorage.getItem("csrftoken"),
        };

        fetch(`/cloud/apps/${itemId}`, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Remove session data
                    localStorage.removeItem("token");
                    localStorage.removeItem("csrftoken");
                    localStorage.removeItem("auth");
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                // Find the specific record by ID

                if (!data.id) {
                    //console.error("No matching data found for the provided ID.");
                    this.setState({ loader: false });
                    return;
                }

                if (data.free_trial_period > 0) {
                    this.setState({ isChecked: true });
                }
                // Populate state with specific data for editing
                this.setState({
                    id: data.id,
                    activeData: data, // All data in case it's still needed
                    doewnloadsData: data.downloads,
                    active_usersData: data.active_users,
                    bannerImage: data.banner_image,
                    iconImage: data.icon_image,
                    name: data.name || "",
                    features: data.features || "",
                    description: data.description || "",
                    editorChoice: data.editor_choice || false,
                    mostDownloaded: data.most_downloaded || false,
                    personalized: data.personalized || false,
                    aiEnabled: data.ai_enabled || false,
                    freeTrialPeriod: data.free_trial_period || 0,
                    costPerDownload: data.cost_per_download || "",
                    fields: Array.isArray(data.offers) ? data.offers : [],
                    distributorPrices: Array.isArray(data.pricing_details) ? data.pricing_details : [],
                    loader: false,
                    distributorPermissions: Array.isArray(data.permissions) ? data.permissions : [],
                    uncheckedDistributors: [] // ✅ Corrected here

                });

                // this.setState
                // console.log(data);

            })
            .catch((err) => {
                console.error(err);
                this.setState({ loader: false });
            });
    };


    handleFieldChange = (e, index, key) => {
        const { value } = e.target;
        this.setState((prevState) => {
            const updatedFields = [...prevState.fields];
            updatedFields[index][key] = value;
            return { fields: updatedFields };
        });
    };

    handleDistributorFieldChange = (e, index, key) => {
        const { value } = e.target;
        this.setState((prevState) => {
            const updatedPrices = [...prevState.distributorPrices];

            // Optional: prevent duplicate countries during edit
            if (key === "country") {
                const isDuplicate = updatedPrices.some(
                    (item, idx) => item.country === value && idx !== index
                );
                if (isDuplicate) {
                    alert("This country is already selected.");
                    return null;
                }
            }
            updatedPrices[index][key] = value;
            return { distributorPrices: updatedPrices };
        });
    };


    handleFormSubmit = async (event) => {
        event.preventDefault();

        const {
            name,
            features,
            description,
            editorChoice,
            mostDownloaded,
            personalized,
            aiEnabled,
            freeTrialPeriod,
            costPerDownload,
            fields,
            distributorPrices,
            bannerImage,
            iconImage,
            status,  // This status will be either 'active' or 'archived'
        } = this.state;

        // Validation only for 'draft' status
        if (status === 'inactive' && !name) {
            alert('Name is required for draft.');
            this.setState({ loader: false }); // Stop loader if validation fails
            return;  // Prevent form submission if name is missing for draft status
        }

        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored,
        };

        // Prepare FormData to send
        const formData = new FormData();
        formData.append("name", name);
        formData.append("features", features);
        formData.append("description", description);
        formData.append("editor_choice", editorChoice);
        formData.append("most_downloaded", mostDownloaded);
        formData.append("personalized", personalized);
        formData.append("ai_enabled", aiEnabled);
        formData.append("free_trial_period", freeTrialPeriod || 0);
        formData.append("cost_per_download", costPerDownload);
        formData.append("status", status);  // Use the status stored in state
        formData.append("offers", JSON.stringify(fields));
        formData.append("country_price", JSON.stringify(distributorPrices));

        // Only append the banner image if it exists
        if (bannerImage) formData.append("banner_image", bannerImage);

        // Only append the icon image if it exists
        if (iconImage) formData.append("icon_image", iconImage);


        const missingFields = [];
        if (!name) missingFields.push("Name");
        if (!features) missingFields.push("Features");
        if (!description) missingFields.push("Description");
        if (!costPerDownload) missingFields.push("Cost Per Download");
        if (missingFields.length > 0) {
            alert(`Please fill in the following fields:\n\n${missingFields.join("\n")}`);
            return;
        }

        // Step 2: If new upload, show confirmation
        if (!this.state.id) {
            const confirmUpload = window.confirm(
                "Please double-check the entered name, as it cannot be edited after upload and will be used for other services within the system."
            );
            if (!confirmUpload) {
                return; // Stop execution if user clicks "No"
            }
        }

        // Step 3: Proceed with submission if everything is valid
        this.setState({ loader: true, status: "active" });

        try {
            const response = await fetch(this.state.id ? "/cloud/apps/" + this.state.id + "/" : "/cloud/apps/", {
                method: this.state.id ? "PUT" : "POST",
                headers: headers,
                body: formData,
            });

            // console.log("formData", formData);

            if (response.ok) {
                const data = await response.json();
                alert("Form submitted successfully!");
                window.location.href = '/marketspace';
            } else {

                const dataerror = await response.json();
                if (dataerror.error) {
                    this.setState({ loader: false }); // Stop loader if validation fails
                    // Handle case where `dataerror.error` exists
                    alert(`Please Provide Image`);
                } else if (dataerror.cost_per_download) {
                    this.setState({ loader: false }); // Stop loader if validation fails
                    // Handle case where `dataerror.cost_per_download` exists
                    alert(`Please Provide cost Per Download.`);
                } else {
                    this.setState({ loader: false }); // Stop loader if validation fails
                    // Handle cases where neither condition is met
                    alert("An unknown error occurred.");
                }

            }
        } catch (error) {
            // console.error("Error submitting form:", error);
            alert("An error occurred while submitting the form.");
        }
    };

    submitUncheckedDistributors = () => {
        const { uncheckedDistributors, id } = this.state;

        // if (uncheckedDistributors.length === 0) {
        //     alert("No changes to submit.");
        //     return;
        // }

        fetch(`/cloud/permissionsDistributor/?app_id=${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                'X-CSRFToken': localStorage.getItem('csrftoken'),
                'Authorization': localStorage.getItem('token'),
            },
            body: JSON.stringify({ distributors: uncheckedDistributors })
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data)
                if (data === "Permission edited !") {
                    this.handleClose(); // Close modal if success message matches
                    this.fetchActiveService(id);
                    alert("Permission Successfull")
                }
                this.setState({ uncheckedDistributors: [] });
            })
            .catch((err) => {
                console.error("Failed to update permissions:", err);
            });
    };


    render() {
        const {
            bannerImage,
            iconImage,
            fields,
            distributorPrices,
            percentage_off,
            coupon,
            name,
            features,
            description,
            isChecked,
            freeTrialPeriod,
            costPerDownload,
            start_date,
            max_usage,
            price,
            end_date,
        } = this.state;

        return (

            <div className="section-background-form">
                {this.state.loader ? <Loader /> : null}
                <div className="form-container">
                    {/* Left Section for Upload */}
                    <div className="left-section">
                        {/* Upload Banner Section */}
                        {/* <div className="upload-box-banner">
                            {!bannerImage && (
                                <label htmlFor="uploadBanner" className="upload-label">
                                    UPLOAD BANNER
                                </label>
                            )}
                            <input
                                type="file"
                                id="uploadBanner"
                                className="file-input"
                                accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                onChange={this.handleBannerUpload}
                            />
                            {bannerImage && <img style={{ objectFit: 'contain' }}
                                src={
                                    typeof bannerImage === "string"
                                        ? bannerImage // Existing image from backend
                                        : URL.createObjectURL(bannerImage) // Preview of uploaded file
                                }
                                alt="Banner" className="uploaded-image" />}
                        </div> */}
                        <div
                            className="upload-box-banner"
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={(e) => e.preventDefault()}
                            onDrop={(e) => {
                                e.preventDefault();
                                const file = e.dataTransfer.files[0];

                                const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
                                const allowedExtensions = /\.(png|jpe?g|svg)$/i;

                                if (
                                    file &&
                                    allowedTypes.includes(file.type) &&
                                    allowedExtensions.test(file.name)
                                ) {
                                    this.handleBannerUpload({ target: { files: [file] } }); // Mimic file input
                                } else {
                                    alert('❌ Only image files (.png, .jpg, .jpeg, .svg) are allowed.');
                                }
                            }}
                        >
                            {!bannerImage && (
                                <label htmlFor="uploadBanner" className="upload-label">
                                    UPLOAD BANNER
                                </label>
                            )}

                            <input
                                type="file"
                                id="uploadBanner"
                                className="file-input"
                                accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                onChange={this.handleBannerUpload}
                            />

                            {bannerImage && (
                                <img
                                    style={{ objectFit: 'contain' }}
                                    src={
                                        typeof bannerImage === "string"
                                            ? bannerImage
                                            : URL.createObjectURL(bannerImage)
                                    }
                                    alt="Banner"
                                    className="uploaded-image"
                                />
                            )}
                        </div>


                        {/* Upload Icon Section */}
                        {/* <div className="upload-box-icon">
                            {!iconImage && (
                                <label htmlFor="uploadIcon" className="upload-label-icon">
                                    UPLOAD ICON
                                </label>
                            )}
                            <input
                                type="file"
                                id="uploadIcon"
                                className="file-input-icon"
                                accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                onChange={this.handleIconUpload}
                            />
                            {iconImage && <img style={{ objectFit: 'contain' }}
                                // src={URL.createObjectURL(iconImage)}
                                src={
                                    typeof iconImage === "string"
                                        ? iconImage // Existing image from backend
                                        : URL.createObjectURL(iconImage) // Preview of uploaded file
                                }
                                alt="Icon" className="uploaded-image-icon" />}
                        </div> */}
                        <div
                            className="upload-box-icon"
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={(e) => e.preventDefault()}
                            onDrop={(e) => {
                                e.preventDefault();
                                const file = e.dataTransfer.files[0];

                                // Strict MIME and extension check
                                const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
                                const allowedExtensions = /\.(png|jpe?g|svg)$/i;

                                if (
                                    file &&
                                    allowedTypes.includes(file.type) &&
                                    allowedExtensions.test(file.name)
                                ) {
                                    this.handleIconUpload({ target: { files: [file] } }); // mimic input change
                                } else {
                                    alert('❌ Only image files (.png, .jpg, .jpeg, .svg) are allowed.');
                                }
                            }}
                        >
                            {!iconImage && (
                                <label htmlFor="uploadIcon" className="upload-label-icon">
                                    UPLOAD ICON
                                </label>
                            )}

                            <input
                                type="file"
                                id="uploadIcon"
                                className="file-input-icon"
                                accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                onChange={this.handleIconUpload}
                            />

                            {iconImage && (
                                <img
                                    style={{ objectFit: 'contain' }}
                                    src={
                                        typeof iconImage === 'string'
                                            ? iconImage
                                            : URL.createObjectURL(iconImage)
                                    }
                                    alt="Icon"
                                    className="uploaded-image-icon"
                                />
                            )}
                        </div>



                        <br />
                        <div className="metrics">
                            <span data-label="Downloads">
                                {/* <span>{this.state.doewnloadsData}+</span> */}
                                <h6>DOWNLOADS</h6>
                                <span>
                                    {this.state.id ? this.state.doewnloadsData : '153'}+
                                </span>

                            </span>
                            <span data-label="Active Users">
                                <h6>ACTIVE USERS</h6>
                                <span>{this.state.id ? this.state.active_usersData : "130"}+</span>
                            </span>
                        </div>
                        <div>
                            <Tooltip title={!this.state.id ? "Available only during edit." : ""} arrow>
                                <span style={{ width: '100%', display: 'inline-block' }}>
                                    <button
                                        disabled={!this.state.id}
                                        className="upload"
                                        style={{
                                            width: '100%',
                                            outline: 'none',
                                            opacity: this.state.id ? 1 : 0.5,
                                            cursor: this.state.id ? 'pointer' : 'not-allowed',
                                            pointerEvents: this.state.id ? 'auto' : 'none'
                                        }}
                                        onClick={this.handleOpen}
                                    >
                                        DISTRIBUTOR PERMISSION
                                    </button>
                                </span>
                            </Tooltip>


                            <Dialog
                                open={this.state.open}
                                onClose={this.handleClose}
                                maxWidth="sm"
                                fullWidth
                                PaperProps={{
                                    style: {
                                        borderRadius: 16,
                                        padding: '24px',
                                        backgroundColor: "#f9f9f9",
                                    }
                                }}
                            >
                                <DialogTitle>
                                    <Typography variant="h6" fontWeight="bold">
                                        Distributor Permission
                                    </Typography>
                                </DialogTitle>

                                <DialogContent>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Choose Who Can Edit App Pricing
                                    </Typography>

                                    <Table size="medium">
                                        <TableHead>
                                            <TableRow sx={{ height: 36 }}> {/* reduce row height */}
                                                <TableCell padding="checkbox" sx={{ py: 0.5 }}>
                                                    <Checkbox size="small" />
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: '550', py: 0.5 }}>Distributor Name</TableCell>
                                                <TableCell sx={{ fontWeight: '550', py: 0.5 }}>Email</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.distributorData.map((distributor) => (
                                                <TableRow key={distributor.si_id} sx={{ height: 36 }}>
                                                    <TableCell padding="checkbox" sx={{ py: 0.5, }}>

                                                        <Checkbox
                                                            size="small"
                                                            defaultChecked={
                                                                Array.isArray(this.state.distributorPermissions)
                                                                    ? !this.state.distributorPermissions.some(
                                                                        (d) => d.si_id === distributor.si_id
                                                                    )
                                                                    : true // fallback to checked if data is not ready
                                                            }

                                                            onChange={(e) => {
                                                                const { si_id, si_name, si_email } = distributor;

                                                                this.setState((prevState) => {
                                                                    const currentUnchecked = Array.isArray(prevState.uncheckedDistributors)
                                                                        ? prevState.uncheckedDistributors
                                                                        : [];

                                                                    if (!e.target.checked) {
                                                                        // Add to unchecked
                                                                        return {
                                                                            uncheckedDistributors: [
                                                                                ...currentUnchecked,
                                                                                { si_id, si_name, si_email }
                                                                            ]
                                                                        };
                                                                    } else {
                                                                        // Remove from unchecked
                                                                        return {
                                                                            uncheckedDistributors: currentUnchecked.filter(
                                                                                (item) => item.si_id !== si_id
                                                                            )
                                                                        };
                                                                    }
                                                                });
                                                            }}

                                                        />

                                                    </TableCell>
                                                    <TableCell sx={{ py: 0.5, height: '10px' }}>{distributor.si_name}</TableCell>
                                                    <TableCell sx={{ py: 0.5, height: '10px' }}>{distributor.si_email}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </DialogContent>
                                <br />
                                <DialogActions>
                                    <Button sx={{
                                        outline: 'none',
                                        backgroundColor: '#DDC7D8',
                                        color: '#000', // Optional: Adjust text color for contrast
                                        '&:hover': {
                                            backgroundColor: '#c16a9a' // Slightly darker on hover
                                        }
                                    }} onClick={this.handleClose} variant="contained">
                                        Close
                                    </Button>
                                    <Button sx={{
                                        outline: 'none',
                                        backgroundColor: '#D9D9D9',
                                        color: '#000', // Optional: Adjust text color for contrast
                                        '&:hover': {
                                            backgroundColor: '#cfcfcf' // Slightly darker on hover
                                        }
                                    }} onClick={this.submitUncheckedDistributors} variant="contained">
                                        Submit
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>

                    {/* Right Section for Form */}
                    <div className="right-section">
                        <h2 className="form-title">{this.state.id ? "EDIT" : "UPLOAD"} YOUR APPLICATION</h2>
                        <form onSubmit={this.handleFormSubmit}>
                            <div className="form-group">

                                <input
                                    type="text"
                                    placeholder="NAME OF THE APPLICATION"
                                    value={name}
                                    onChange={(e) => {
                                        let value = e.target.value
                                            .replace(/[^a-zA-Z ]/g, '')  // allow only letters and spaces
                                            .toUpperCase();             // convert to uppercase

                                        // Prevent setting only spaces
                                        if (value.trim() === '' && value !== '') return;

                                        this.handleInputChange({ target: { value } }, "name");
                                    }}
                                    maxLength={26}
                                />
                            </div>

                            <div className="form-group">
                                <textarea
                                    className=""
                                    placeholder="FEATURES OF THE APPLICATION"
                                    value={features}
                                    onChange={(e) => {
                                        let value = e.target.value
                                            .replace(/[^a-zA-Z ,]/g, '') // ✅ allow letters, spaces, and commas only
                                            .toUpperCase();             // convert to uppercase

                                        // Prevent setting only spaces
                                        if (value.trim() === '' && value !== '') return;

                                        this.handleInputChange({ target: { value } }, "features");
                                    }}
                                    maxLength={127}
                                />

                            </div>

                            <div className="form-group">
                                <textarea
                                    placeholder="DESCRIPTION OF THE APPLICATION"
                                    value={description}
                                    onChange={(e) => {
                                        let value = e.target.value
                                            .replace(/[^a-zA-Z ,]/g, '') // ✅ allow letters, spaces, and commas only
                                            .toUpperCase();             // Convert to uppercase

                                        // Prevent saving only-space input
                                        if (value.trim() === '' && value !== '') return;

                                        this.handleInputChange({ target: { value } }, "description");
                                    }}
                                    maxLength={127}
                                />
                            </div>

                            <div className="checkbox-group" style={{ marginTop: "15px" }}>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="editor-choice"
                                        checked={this.state.editorChoice}
                                        onChange={(e) => this.setState({ editorChoice: e.target.checked })}
                                    />
                                    <label htmlFor="editor-choice">EDITOR’S CHOICE</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="most-downloaded"
                                        checked={this.state.mostDownloaded}
                                        onChange={(e) => this.setState({ mostDownloaded: e.target.checked })}
                                    />
                                    <label htmlFor="most-downloaded">MOST DOWNLOADED</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="personalized"
                                        checked={this.state.personalized}
                                        onChange={(e) => this.setState({ personalized: e.target.checked })}
                                    />
                                    <label htmlFor="personalized">PERSONALIZED</label>
                                </div>
                                <div className="checkbox-group-item">
                                    <input
                                        type="checkbox"
                                        id="ai-enabled"
                                        checked={this.state.aiEnabled}
                                        onChange={(e) => this.setState({ aiEnabled: e.target.checked })}
                                    />
                                    <label htmlFor="ai-enabled">AI-ENABLED</label>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="form-group-free-trail">
                                    <div className="checkbox-group-item">
                                        <input
                                            type="checkbox"
                                            id="free-trail"
                                            checked={isChecked}
                                            onChange={this.handleCheckboxChange}
                                        />
                                        <label htmlFor="free-trail">FREE TRAIL PERIOD:</label>
                                    </div>
                                    <input
                                        type="number"
                                        placeholder="Ex: 20 days"
                                        className="trial-days-input"
                                        disabled={!isChecked}
                                        value={freeTrialPeriod}
                                        onChange={(e) => this.handleInputChange(e, "freeTrialPeriod")}
                                        title={!isChecked ? "Please check the free trial box to enable the input." : ""}
                                        min={0}
                                        max={100}

                                    />
                                </div>
                            </div>

                            <div className="form-group" style={{ marginTop: "15px", }}>
                                <input
                                    type="number"
                                    placeholder="COST PER DOWNLOAD"
                                    value={costPerDownload}
                                    max="10000" // Maximum value allowed
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Ensure the number is within the allowed range
                                        if (value === "" || (Number(value) >= 0 && Number(value) <= 10000)) {
                                            this.handleInputChange(e, "costPerDownload");
                                        }
                                    }}
                                    onWheel={(e) => e.target.blur()} // ⛔ disables scroll-wheel input
                                />
                            </div>

                            {/* Start Date & End Date Start  */}
                            {/* <div className="form-group-inline" style={{ marginTop: "15px", }} >
                                <span className="start_date">
                                    <p style={{ marginBottom: '1px', fontSize: '10px', marginLeft: '10%', color: 'rgba(0, 0, 0, 0.85)' }}>START DATE</p>
                                    <input
                                        type="date"
                                        placeholder="START DATE"
                                        value={start_date} // Track start date separately
                                        min={new Date().toISOString().split("T")[0]}
                                        onChange={(e) => this.handleInputChange(e, "start_date")}
                                    />
                                </span>
                                <span className="end_date">
                                    <p style={{ marginBottom: '1px', fontSize: '10px', marginLeft: '10%', color: 'rgba(0, 0, 0, 0.85)' }}>END DATE</p>
                                    <input
                                        type="date"
                                        placeholder="END DATE"
                                        value={end_date} // Track end date separately
                                        min={start_date || new Date().toISOString().split("T")[0]} // End date must be after start date
                                        onChange={(e) => this.handleInputChange(e, "end_date")}
                                    />
                                </span>
                            </div> */}
                            {/* <div className="form-group-inline" style={{ marginTop: "15px" }}>
                                <span className="start_date">
                                    <p
                                        style={{
                                            marginBottom: '1px',
                                            fontSize: '10px',
                                            marginLeft: '10%',
                                            color: 'rgba(0, 0, 0, 0.85)',
                                        }}
                                    >
                                        START DATE
                                    </p>
                                    <input
                                        type="date"
                                        placeholder="START DATE"
                                        value={start_date}
                                        min={new Date().toISOString().split("T")[0]}
                                        onChange={(e) => this.handleInputChange(e, "start_date")}
                                    />
                                </span>

                                <span className="end_date">
                                    <p
                                        style={{
                                            marginBottom: '1px',
                                            fontSize: '10px',
                                            marginLeft: '10%',
                                            color: 'rgba(0, 0, 0, 0.85)',
                                        }}
                                    >
                                        END DATE
                                    </p>
                                    <input
                                        type="date"
                                        placeholder="END DATE"
                                        value={end_date}
                                        disabled={!start_date}
                                        min={
                                            start_date
                                                ? new Date(new Date(start_date).setDate(new Date(start_date).getDate() + 1))
                                                    .toISOString()
                                                    .split("T")[0]
                                                : new Date().toISOString().split("T")[0]
                                        }
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            if (start_date && selected <= start_date) {
                                                alert("End Date must be after Start Date");
                                                return;
                                            }
                                            this.handleInputChange(e, "end_date");
                                        }}
                                    />
                                </span>
                            </div> */}

                            <div className="form-group-inline" style={{ marginTop: "15px" }}>
                                <span className="start_date">
                                    <p
                                        style={{
                                            marginBottom: '1px',
                                            fontSize: '10px',
                                            marginLeft: '10%',
                                            color: 'rgba(0, 0, 0, 0.85)',
                                        }}
                                    >
                                        START DATE
                                    </p>
                                    <input
                                        type="date"
                                        placeholder="START DATE"
                                        value={start_date}
                                        min={new Date().toISOString().split("T")[0]}
                                        max={
                                            end_date
                                                ? new Date(new Date(end_date).setDate(new Date(end_date).getDate() - 1))
                                                    .toISOString()
                                                    .split("T")[0]
                                                : undefined
                                        }
                                        onChange={(e) => {
                                            const selectedStart = e.target.value;
                                            if (end_date && selectedStart >= end_date) {
                                                alert("Start Date must be before End Date");
                                                return;
                                            }
                                            this.handleInputChange(e, "start_date");
                                        }}
                                    />
                                </span>

                                <span className="end_date">
                                    <p
                                        style={{
                                            marginBottom: '1px',
                                            fontSize: '10px',
                                            marginLeft: '10%',
                                            color: 'rgba(0, 0, 0, 0.85)',
                                        }}
                                    >
                                        END DATE
                                    </p>
                                    <input
                                        type="date"
                                        placeholder="END DATE"
                                        value={end_date}
                                        disabled={!start_date}
                                        min={
                                            start_date
                                                ? new Date(new Date(start_date).setDate(new Date(start_date).getDate() + 1))
                                                    .toISOString()
                                                    .split("T")[0]
                                                : new Date().toISOString().split("T")[0]
                                        }
                                        onChange={(e) => {
                                            const selectedEnd = e.target.value;
                                            if (start_date && selectedEnd <= start_date) {
                                                alert("End Date must be after Start Date");
                                                return;
                                            }
                                            this.handleInputChange(e, "end_date");
                                        }}
                                    />
                                </span>
                            </div>


                            {/* Start Date & End Date End */}

                            <div className="form-group-inline" style={{ marginTop: "15px" }} >
                                <input
                                    type="number"
                                    placeholder="OFFER IN %"
                                    value={percentage_off}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Ensure the number is within the allowed range
                                        if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
                                            this.handleInputChange(e, "percentage_off");
                                        }
                                    }}
                                    max={100} // Maximum value
                                />
                                <input
                                    type="text"
                                    placeholder="COUPON ID"
                                    value={coupon}
                                    onChange={(e) => this.handleInputChange(e, "coupon")}
                                />

                                <input
                                    type="number"
                                    placeholder="MAX USE"
                                    value={max_usage}
                                    onChange={(e) => this.handleInputChange(e, "max_usage")}
                                    max="99" // Maximum value allowed

                                />
                                <span className="plus-sign" onClick={this.handleAddField}>
                                    +
                                </span>
                            </div>
                            {/* Render the list of input fields */}
                            {fields.map((field, index) => (
                                <div key={index}>
                                    <div style={{
                                        border: "1.4px solid #ffa47c",
                                        borderRadius: "33px",
                                        marginTop: "3%",
                                        flexDirection: "column",  // Arrange items in a column
                                        justifyContent: "center", // Center items vertically
                                        alignItems: "center", // Center items horizontally
                                        padding: "10px", // Add some padding
                                        textAlign: "center", // Align text in center
                                    }}>
                                        <div className="form-group-inline" style={{ marginBottom: '15px' }}>
                                            <span style={{ width: '100%' }}>
                                                <p style={{ textAlign: 'start', marginLeft: '10%', marginBottom: '1px', fontSize: '10px', color: 'rgba(0, 0, 0, 0.85)' }}>START DATE</p>
                                                <input style={{ width: '100%' }} type="date" value={field.start_date} placeholder="START DATE" onChange={(e) => this.handleFieldChange(e, index, "start_date")}
                                                />
                                            </span>
                                            <span style={{ width: '100%' }}>
                                                <p style={{ textAlign: 'start', marginLeft: '10%', marginBottom: '1px', fontSize: '10px', color: 'rgba(0, 0, 0, 0.85)' }}>END DATE</p>
                                                <input style={{ width: '100%' }} min={field.start_date} type="date" value={field.end_date} placeholder="END DATE" onChange={(e) => this.handleFieldChange(e, index, "end_date")} />
                                            </span>
                                        </div>
                                        <div className="form-group-inline">
                                            <input
                                                style={{ width: '100%' }}
                                                type="number"
                                                placeholder="OFFER IN %"
                                                value={field.percentage_off || ""}
                                                onChange={(e) => {
                                                    let value = Number(e.target.value);

                                                    // Ensure the value stays within 0-99
                                                    if (value < 0) value = 0;
                                                    if (value > 99) value = 99;

                                                    this.handleFieldChange({ target: { value: value } }, index, "percentage_off");
                                                }}
                                            />

                                            <input type="text" value={field.coupon} placeholder="COUPON ID" onChange={(e) => this.handleFieldChange(e, index, "coupon")}
                                            />
                                            <input
                                                style={{ width: '100%' }}
                                                type="number"
                                                placeholder="MAX USE"
                                                value={field.max_usage || ""}

                                                onChange={(e) => this.handleFieldChange(e, index, "max_usage")}
                                            />
                                            <span className="plus-sign" onClick={() => this.handleDelete(index)}>
                                                <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px' }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className="form-group-inline" style={{ marginTop: "15px" }} >
                                <select
                                    style={{
                                        width: '100%',
                                        outline: 'none',
                                        padding: '12px 20px',
                                        background: '#f5f5f5',
                                        borderRadius: '33px',
                                        border: '1.4px solid #ffa47c',
                                        fontSize: '12px',
                                        color: 'gray'
                                    }}
                                    value={this.state.DistributorCountry || ''}
                                    onChange={(e) => this.handleInputChange(e, "DistributorCountry")}>
                                    <option value="" disabled>
                                        SELECT COUNTRY
                                    </option>
                                    {distributorCountry.map((option, index) => (
                                        <option key={index} value={option.label}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>

                                <input
                                    type="number"
                                    placeholder="PRICE"
                                    value={price}
                                    onChange={(e) => this.handleInputChange(e, "price")}
                                    // max="99" // PRICE value allowed
                                    style={{
                                        padding: '10px 20px',
                                        background: '#f5f5f5',
                                        borderRadius: '33px',
                                        border: '1.4px solid #ffa47c',
                                        // fontSize: '11px',
                                        width: '100%',
                                    }}
                                />
                                <span className="plus-sign"
                                    style={{ width: '27%' }}
                                    onClick={this.handleAddCountryPriceField}>
                                    +
                                </span>
                            </div>

                            {distributorPrices.map((field, index) => (

                                <div key={index}>
                                    <div style={{
                                        border: "1.4px solid #ffa47c",
                                        borderRadius: "33px",
                                        marginTop: "3%",
                                        flexDirection: "column",  // Arrange items in a column
                                        justifyContent: "center", // Center items vertically
                                        alignItems: "center", // Center items horizontally
                                        padding: "10px", // Add some padding
                                        textAlign: "center", // Align text in center
                                    }}>

                                        <div className="form-group-inline" style={{ marginBottom: "10px" }}>
                                            <select
                                                style={{
                                                    width: '100%',
                                                    outline: 'none',
                                                    padding: '12px 20px',
                                                    background: '#f5f5f5',
                                                    borderRadius: '33px',
                                                    border: '1.4px solid #ffa47c',
                                                    fontSize: '12px',
                                                    color: 'gray'
                                                }}
                                                value={field.country || ''}
                                                onChange={(e) => this.handleDistributorFieldChange(e, index, "country")}
                                            >
                                                <option value="" disabled>SELECT COUNTRY</option>
                                                {distributorCountry.map((option, i) => (
                                                    <option key={i} value={option.label}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group-inline">
                                            <input
                                                style={{ width: '100%' }}
                                                type="number"
                                                placeholder="PRICE"
                                                value={field.price || ""}
                                                onChange={(e) => this.handleDistributorFieldChange(e, index, "price")}
                                            />
                                            <span className="plus-sign" onClick={() => this.handleDeleteCountryPrice(index)}>
                                                <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px' }} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className="button-group">
                                <button
                                    type="submit"
                                    className="draft"
                                    onClick={() => {
                                        this.setState({ loader: false, status: 'inactive' }, () => {
                                            // alert(this.state.id ? "You clicked EDIT DRAFT" : "You clicked DRAFT");
                                        });
                                    }}
                                >
                                    {this.state.id ? "EDIT DRAFT" : "DRAFT"}
                                </button>

                                <button type="submit" className="upload">
                                    {this.state.id ? "EDIT UPLOAD" : "UPLOAD"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redux: state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketSpaceForm);

